// import { NoNetwork } from "components/NoNetwork";
import asyncComponentLoader from "core/loader";
import React, { ReactNode, useState, useEffect } from "react";

// Type for the props of the RequireNetwork component
interface RequireNetworkProps {
  children: ReactNode; // ReactNode allows any valid React child component (JSX elements, strings, etc.)
}

const RequireNetwork: React.FC<RequireNetworkProps> = ({ children }) => {
  // State to track the online status
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const NoNetwork = asyncComponentLoader(() =>
    import("components/NoNetwork").then(({ NoNetwork }) => ({
      default: NoNetwork,
    })),
  );
  // Effect hook to handle online/offline events
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Listen for online and offline events
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Cleanup listeners when the component is unmounted
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // If the user is offline, return an offline message or modal
  if (!isOnline) {
    return <NoNetwork />;
  }

  // If the user is online, render the children components
  return <>{children}</>;
};

export default RequireNetwork;
